import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'website',
      component: () => import('./../page/website.vue') // PC官网
    },
    {
      path: '/pearCatHome',
      name: 'pearCatHome',
      component: () => import('./../page/pearCat/pearCatHome.vue') // 梨猫首页
    },
    {
      path: '/pearCatAbout',
      name: 'pearCatAbout',
      component: () => import('./../page/pearCat/pearCatAbout.vue') // 梨猫页
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js